import React from 'react';
import { Link } from 'react-router-dom';
import { MyIcon } from '../../common/baseConfig';
import defaultImg from '../../images/default.jpg';
import { Button } from 'antd';
function AdvModelItem(props) {
  const { width, height, model, imargin } = props || {};
  const { OpenType = 0, AdvertiseUrl = '', AdvertiseImage = '' } = model || {};
  return (
    <a
      style={{ width: width + 'px', height: height + 'px' }}
      target={OpenType === 1 ? '_blank' : '_self'}
      href={AdvertiseUrl || '#'}
      className={`adv_item_public ${imargin ? imargin : ''}`}
    >
      <img
        className="adv_item_public_img"
        src={AdvertiseImage || ''}
        alt={AdvertiseImage ? 'have' : ''}
      />
    </a>
  );
}

function BannerCourseItem(props) {
  let { imargin, subject } = props;
  if (!subject) {
    subject = {
      CourseImg: null,
      CourseName: '',
      Price: null,
      peopleCount: 0,
    };
  }
  imargin = imargin ? imargin : '';
  if (!subject.Course_ID) {
    return <span></span>;
  }
  return (
    <div className={`content_public_item ${imargin ? imargin : ''}`}>
      <Link
        target="_blank"
        to={
          subject.CourseType === 1
            ? '/coursepack/detail/' + subject.Course_ID
            : '/course/detail/' + subject.Course_ID
        }
      >
        <img
          alt=""
          className="content_public_item_image"
          src={
            subject.CourseImg
              ? subject.CourseImg + '?x-oss-process=image/resize,m_fixed,h_158,w_281'
              : defaultImg
          }
        />
        <div className="content_public_item_detail">
          <p className="content_public_item_title">{subject.CourseName || '默认标题'}</p>
          <div className="content_public_item_message">
            {subject.TemplateTypes !== 1 && (
              <p className="content_public_item_price">
                {subject.Price ? '￥' + subject.Price : '免费'}
              </p>
            )}
            <div
              className="content_public_item_learner"
              style={subject.TemplateTypes === 1 ? { marginLeft: 0 } : {}}
            >
              <i className="people_icon"></i>
              <span className="content_public_item_number">{subject.peopleCount}</span>
            </div>
            {subject.TemplateTypes === 1 && (
              <div
                className="content_public_item_btn"
                onClick={e => {
                  e.preventDefault();
                  subject.pushTo(
                    `/course/video/${subject.Course_ID}-${subject.CourseChapterID}-${subject.CourseWareID}`,
                  );
                  window.scrollTo(0, 0);
                }}
              >
                <Button className="try-btn" type="theme2">
                  <span>免费试听</span>
                  <MyIcon type="iconmianfeishiting" className="try-icon" />
                </Button>
              </div>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
}

export { BannerCourseItem, AdvModelItem };



// WEBPACK FOOTER //
// ./src/features/home/publicComponent.js